import React, { useState } from 'react';
import classNames from 'classnames/bind';
import style from './DownloadReasonModal.module.scss';
import Modal from '../../components/common/modal/Modal';
import ButtonCommon from '../../components/common/button/ButtonCommon';
import { useDownloadReasonStore } from './downloadReasonStore';

const cx = classNames.bind(style);
const MAX_LENGTH = 200;

const DownloadReasonModal = () => {
  const isOpen = useDownloadReasonStore((state) => state.resolve !== null);
  const close = useDownloadReasonStore((state) => state.close);
  const [reason, setReason] = useState('');

  if (!isOpen) return null;

  const finish = (value: string | null) => {
    setReason('');
    close(value);
  };

  return (
    <Modal onClose={() => finish(null)} isCloseOnClickBackdrop>
      <form
        className={cx('container')}
        onSubmit={(e) => {
          e.preventDefault();
          if (reason.trim()) finish(reason.trim());
        }}
      >
        <h3 className={cx('title')}>다운로드 사유</h3>
        <p className={cx('description')}>개인정보가 포함된 파일입니다. 사유는 관리자 활동 기록에 남습니다.</p>
        <textarea
          id={'download-reason'}
          className={cx('textarea')}
          value={reason}
          maxLength={MAX_LENGTH}
          placeholder={'예: 고객사 가입 현황 보고'}
          onChange={(e) => setReason(e.target.value)}
          autoFocus
        />
        <div className={cx('buttons')}>
          <ButtonCommon onClick={() => finish(null)}>취소</ButtonCommon>
          <ButtonCommon submitType disabled={!reason.trim()}>
            다운로드
          </ButtonCommon>
        </div>
      </form>
    </Modal>
  );
};

export default DownloadReasonModal;
